import api from "@/services/apiService";
import axios from "axios";
import { resolveApiBaseUrl } from "@/utils/hostname";
import { buildHeaders } from "./_headers.util";

export default {
  getSummary() {
    return api.get("billing");
  },

  payWithMpesa(payload) {
    return api.post("billing/mpesa/pay", payload);
  },

  payByBankTransfer(formData) {
    return axios.post(`${resolveApiBaseUrl()}billing/bank-transfer/pay`, formData, {
      headers: buildHeaders({}, { multipart: true }),
      withCredentials: true,
    });
  },
};
